class rolesId {
  constructor(id, name, description, insurable, operators,paInicioAsegId) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.insurable = insurable;
    this.operators = operators;
    this.paInicioAsegId=paInicioAsegId
  }
  static fromJson({ rolId, nombre, descripcion, asegurables, operadores,paInicioAsegId }) {
    return new rolesId(rolId, nombre, descripcion, asegurables, operadores,paInicioAsegId);
  }
}
export default rolesId;
